// Classic / New UI switch. The choice is per browser (localStorage) and Classic is the default.
// Switching reloads the page because the two UIs use different global layouts.

export const UI_MODE_KEY = 'apworks.uiMode';
export const UI_CLASSIC = 'classic';
export const UI_NEW = 'new';

export function getUiMode() {
	try {
		return localStorage.getItem(UI_MODE_KEY) === UI_NEW ? UI_NEW : UI_CLASSIC;
	} catch {
		return UI_CLASSIC;
	}
}

export function isNewUi() {
	return getUiMode() === UI_NEW;
}

export function setUiMode(mode) {
	try {
		localStorage.setItem(UI_MODE_KEY, mode === UI_NEW ? UI_NEW : UI_CLASSIC);
	} catch {
		// Storage can be blocked (private mode, policy). Stay on the current UI.
		return;
	}
	window.location.reload();
}
